module.exports = __webpack_public_path__ + "img/tandoori.d1a53390.jpeg";